export enum ClientHttpPaths {
  Clients = '/clients',
  ClientsDetails = '/clients/{clientCode}',
  Notifications = '/clients/{clientCode}/notifications',
  ClientNameChange = '/clients/{clientCode}/name',
}
